import { useState } from 'react'
import { SEATS, SEAT_LABEL, readSeat, writeSeat, type Seat } from '../lib/seat'
import styles from './SeatPicker.module.css'

/**
 * THE ENGINE SEAT, as an admin control on the shelf.
 *
 * ⚠ ADMIN-ONLY, AND THAT IS THE WHOLE OF WHY IT IS ALLOWED TO EXIST. A quality chooser shown to a
 * paying player is what `doctrine-pricing-and-monetization.md` rules out by name; the operative
 * line (spec §3.5) is *whether a chooser is ever rendered to somebody being charged*. This one is
 * a founder's instrument for answering an empirical question — can the cheap seat hold a
 * character — and it changes no price. Widening it is a ruling, not a props change.
 *
 * ⚠ IT TAKES EFFECT ON THE NEXT SITTING, never the one already open. The seat is fixed at session
 * creation like the language, because a thread written half by one model and half by another is a
 * comparison that proves nothing.
 *
 * The label names the MODEL rather than a quality, deliberately: calling the default anything less
 * than the other would be the product asserting its own shipped experience is the lesser one,
 * which is the claim the bench exists to settle and nobody has settled yet.
 */
export default function SeatPicker({ className }: { className?: string }) {
  const [seat, setSeat] = useState<Seat>(readSeat)

  return (
    <label className={`${styles.wrap} ${className ?? ''}`}>
      <span className={styles.label}>seat</span>
      <select
        className={styles.select}
        value={seat}
        onChange={(e) => {
          const next = e.target.value as Seat
          setSeat(next)
          writeSeat(next)
        }}
      >
        {SEATS.map((s) => (
          <option key={s} value={s}>
            {SEAT_LABEL[s]}
          </option>
        ))}
      </select>
    </label>
  )
}
